<div class="container">
  <button mat-icon-button *ngIf="nbNotificationsNonVue > 0" [matMenuTriggerFor]="notification">
    <mat-icon [matBadge]="nbNotificationsNonVue" matBadgeColor="warn" matBadgePosition="before"> notification_important </mat-icon>
  </button>
  <button mat-icon-button *ngIf="nbNotificationsNonVue === 0">
    <mat-icon [matMenuTriggerFor]="notification">notification_important</mat-icon>
  </button>

  <div class="name-container">
    <p>{{ userProfile?.firstName }} {{ userProfile?.lastName }}</p>
    <p class="profileUser">{{ profile }}</p>
  </div>

  <app-menu-profil></app-menu-profil>

  <mat-icon class="account">account_circle</mat-icon>
</div>
<mat-menu #notification="matMenu" xPosition="before">
  <span id="notification-panel-title">Notifications</span>
  <span id="notification-settigns">
    <a href="/utilisateur/parametre" title="Paramètres des notifications"><mat-icon>settings</mat-icon></a>
  </span>
  <mat-divider></mat-divider>
  <div class="notification-list">
    <div class="timeline">
      <span *ngIf="notifications.mouvement_financier?.length">
        <span class="notification-panel-subtitle">{{ notifications.mouvement_financier?.length }} mouvements financiers en attente</span>
        <ng-container *ngFor="let notif of notifications.mouvement_financier">
          <div class="timeline-item">
            <div class="notification-wrapper">
              <button
                mat-menu-item
                [class]="'notification virement'"
                [ngClass]="'unread'"
                (click)="afficherDetailVirement(notif.objectUuid, notif.uuid)">
                <span class="notification-content">
                  {{ notif.message }}
                  <mat-icon>search</mat-icon>
                </span>
              </button>
              <mat-icon class="close-icon" (click)="$event.stopPropagation(); suppressionNotification(notif.uuid)">close</mat-icon>
            </div>
          </div>
        </ng-container>
      </span>

      <div *ngIf="notifications.commande?.length">
        <span class="notification-panel-subtitle">Commandes</span><br />
        <ng-container *ngFor="let notif of notifications.commande; let last = last">
          <span *ngIf="notif.dateCreation && showNotificationDate(notif.dateCreation)" class="notification-panel-date">{{
            notif.dateCreation
          }}</span>
          <div class="timeline-item" [class.is-last]="last">
            <div class="notification-wrapper">
            <button
              mat-menu-item
              [class]="'notification ' + notif.type"
              [ngClass]="{ unread: !notif.vue }"
              (click)="goToRoute(notif.uuid, notif.route)"><span class="notification-content">
              {{ notif.message }}</span>
            </button><mat-icon class="close-icon" (click)="$event.stopPropagation(); suppressionNotification(notif.uuid)">close</mat-icon>
          </div>
          </div>
        </ng-container>
      </div>

      <span *ngIf="notifications.marches?.length">
        <span class="notification-panel-subtitle">Marchés</span><br />
        <ng-container *ngFor="let notif of notifications.marches; let last = last">
          <span *ngIf="notif.dateCreation && showNotificationDate(notif.dateCreation)" class="notification-panel-date">{{
            notif.dateCreation
          }}</span>
          <div class="timeline-item" [class.is-last]="last">
            <button
              mat-menu-item
              [class]="'notification ' + notif.type"
              [ngClass]="{ unread: !notif.vue }"
              (click)="goToRoute(notif.uuid, notif.route)">
              {{ notif.message }}
            </button>
          </div>
        </ng-container>
      </span>
    </div>
  </div>
</mat-menu>
